<div class="d-flex flex-column h-100 overflow-hidden">
  <div class="d-flex align-items-center gap-2 px-1 pb-3">
    <h2 class="fs-16 mb-0">APS History</h2>
    @if (prospectDeals().length > 1) {
      <span class="badge bg-primary fs-12 fw-500"> {{ prospectDeals().length }} APS </span>
    }
  </div>

  <hr class="mt-0 mb-2" />

  <div class="flex-fill overflow-hidden">
    <div class="h-100 d-flex flex-column gap-2 overflow-y-auto pe-2 pb-3">
      @for (deal of prospectDeals(); track deal.id) {
        <div
          class="deal-card border"
          role="button"
          [class.active]="selectedDealId() === deal.id"
          (click)="selectDeal(deal.id); showHideDeals()"
        >
          <div class="deal-card-header">
            <div class="deal-name d-flex flex-wrap flex-xl1-nowrap align-items-center mb-1 gap-2 w-100">
              <h3 class="fw-500 fs-14 mb-0">
                {{ deal.lot.lotNo || '[LOT NAME]' }}
              </h3>

              @if (deal.dealStatus) {
                <span class="ms-auto text-nowrap">
                  <lib-sign-status-badge
                    [class]="selectedDealId() === deal.id ? 'secondary' : undefined"
                    [status]="deal.dealStatus.id"
                  ></lib-sign-status-badge>
                </span>
              }
            </div>
          </div>

          <div class="deal-card-body">
            <div class="project-name d-flex flex-column mb-2">
              <label class="fs-10 d-block text-uppercase fw-500">Project</label>
              <span class="fs-14">
                {{ deal.lot.projectCode || '-' }}
              </span>
            </div>
            <div class="deal-info-row d-flex flex-column flex-column mb-2">
              <span class="label fw-500 me-2 d-flex fs-10 text-uppercase">Model/Elevation: </span>
              <span class="value fs-14">
                @if (deal?.model?.modelName && deal?.elevation?.elevationCode) {
                  {{ deal?.model?.modelName }}
                  /
                  {{ deal?.elevation?.elevationCode }}
                } @else {
                  -
                }
              </span>
            </div>

            <div class="d-flex justify-content-between align-top">
              <div class="deal-info-row d-flex flex-column">
                <span class="label fw-500 me-2 d-flex fs-10 text-uppercase">Contract Date: </span>
                <span class="value fs-14">
                  {{ deal?.contract?.contractDate ? (deal?.contract?.contractDate | date: 'MMM d, y') : '-' }}
                </span>
              </div>

              <div class="deal-info-row d-flex flex-column flex-column mb-2">
                <span class="label fw-500 me-2 d-flex fs-10 text-uppercase">Target Date: </span>
                <span class="value fs-14">
                  {{ deal?.contract?.targetClosingDate ? (deal?.contract?.targetClosingDate | date: 'MMM d, y') : '-' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      } @empty {
        <div class="flex-fill d-flex flex-column align-items-center justify-content-center h-100 text-muted gap-2">
          <i class="bi bi-tag fs-48"></i>
          <p class="mb-0">No APS found</p>
        </div>
      }
    </div>
  </div>
</div>
